import { render, staticRenderFns } from "./ApplicantsMnsView.vue?vue&type=template&id=010ae1c8&scoped=true&"
import script from "./ApplicantsMnsView.vue?vue&type=script&lang=js&"
export * from "./ApplicantsMnsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010ae1c8",
  null
  
)

export default component.exports